import { memo } from 'react';
import { Wallet } from 'lucide-react';

interface DepositJumpBannerProps {
  offscreenCount: number;
  onJump: () => void;
}

function DepositJumpBannerBase({ offscreenCount, onJump }: DepositJumpBannerProps) {
  if (offscreenCount === 0) return null;
  // 시각 가시성 지표(라이브 리전 아님): 스크롤/검색으로 가려진 매칭 행이 있을 때만 표시.
  // role=status/aria-live는 두지 않는다 — 스크롤·검색마다 '입금 도착'으로 오인 방송되는 것 방지.
  // 실제 신규 입금 알림은 별도(토스트)에서 announce.
  return (
    <div className="mb-2 flex items-center justify-between bg-blue-500 text-white text-xs rounded-md py-1.5 px-3 shadow">
      <span className="flex items-center gap-1.5 font-medium">
        <Wallet className="w-3.5 h-3.5" aria-hidden /> 안 보이는 입금 {offscreenCount}건
      </span>
      <button
        type="button"
        onClick={onJump}
        aria-label={`숨겨진 입금 ${offscreenCount}건 보기`}
        className="h-6 px-2.5 rounded bg-white/20 hover:bg-white/30 font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
      >
        보기
      </button>
    </div>
  );
}

export const DepositJumpBanner = memo(DepositJumpBannerBase);
